import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogProps } from '../../domain/model/common/confirmDialogProps';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css'
})

  export class ConfirmDialogComponent implements OnInit {

    constructor(private readonly router: Router,
        public dialogo: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogProps: ConfirmDialogProps) { }
    
        goBack(): void {
          this.router.navigate([this.dialogProps.backComponent]);
          this.dialogo.close(false);
        }
        confirm(): void {
          this.dialogo.close(true);
        }
        close(): void {
          this.dialogo.close(true);
        }
        
    
      ngOnInit() {
      }
    
    }

